module.exports = __webpack_public_path__ + "img/qmpfl-icon.e4992cf2.png";